import React from "react";
import './queries.css'
import { Link } from 'react-router-dom'
import { useDispatch } from "react-redux";
import { useEffect } from "react"

const Queries: React.FC = () => {
    // reset the rejected state, so it can be displayed again
    // this state change should not affect this compoennt
    const rootDispatch = useDispatch()
    useEffect(() => {
        document.title = "Codelist"
        // returning the dispatch to avoid unneccessary rerender
        return (() => {
            rootDispatch({ type: "App/DISCLAIMERRESET" })
        })
    })

    return (
        <div id="content">
            <ul className="index-list">                                
                <li><Link to="/securitycriteria">Securities Database</Link></li>                 
            </ul>
        </div>
    )
}

export default Queries